import copy from "copy-to-clipboard";
import { Alert, Button, Card, Modal } from "react-bootstrap";
import { UseFormWatch } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import { ReactComponent as WarningSVG } from "go-core/images/svg/warning-alert.svg";
import { CreateOrganizationClientGrantApi } from "../../../services/types";

interface Props {
	watch: UseFormWatch<CreateOrganizationClientGrantApi>;
}

const ClientGrantCreatedModal = ({ watch }: Props) => {
	const { t } = useTranslation("lib");
	const { secret_id, client_id } = watch();
	const { addFlash } = useFlash();

	const copyCredentialsHandler = async () => {
		const clipboardText = `${t("go_component.client_grants.field.client_id.title")}: ${client_id}\n${t(
			"go_component.client_grants.field.secret_id.title"
		)}: ${secret_id}`;

		copy(clipboardText, {
			format: "text/plain",
			onCopy: () => {
				addFlash({
					type: "success",
					msg: t("go_component.client_grants.action.data_copied.title"),
				});
			},
		});
	};

	return (
		<>
			<Modal.Header closeButton>
				<Modal.Title>{t("go_component.client_grants.header.access_data.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="client-grant-created-modal">
				<Alert variant="warning" className="bg-warning bg-opacity-10 d-flex align-items-center gap-3">
					<WarningSVG className="icon client-grant-created-modal__warning-svg flex-shrink-0" />
					<span>{t("go_component.client_grants.field.secret_id.help_text")}</span>
				</Alert>
				<Card>
					<Card.Body className="d-flex flex-column row-gap-3">
						<div className="d-flex flex-column gap-y-2">
							<span>
								{`${t("go_component.client_grants.field.client_id.title")}: `}
								<span className="client-grant-created-modal__sensitive-data text-muted">
									{client_id}
								</span>
							</span>
							<span>
								{`${t("go_component.client_grants.field.secret_id.title")}: `}
								<span className="client-grant-created-modal__sensitive-data text-muted">
									{secret_id}
								</span>
							</span>
						</div>
						<Button
							variant="light"
							size="sm"
							className="border align-self-start"
							onClick={copyCredentialsHandler}
						>
							{t("go_component.client_grants.action.copy_data.title")}
						</Button>
					</Card.Body>
				</Card>
			</Modal.Body>
		</>
	);
};

export default ClientGrantCreatedModal;
